import { render, staticRenderFns } from "./add-notification-model.vue?vue&type=template&id=78036788&scoped=true&"
import script from "./add-notification-model.vue?vue&type=script&lang=js&"
export * from "./add-notification-model.vue?vue&type=script&lang=js&"
import style0 from "./add-notification-model.vue?vue&type=style&index=0&id=78036788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78036788",
  null
  
)

component.options.__file = "add-notification-model.vue"
export default component.exports